// extracted by mini-css-extract-plugin
export default {"wrap":"Card_wrap__29goN","inner":"Card_inner__HBKR+","label":"Card_label__VH4A4","value":"Card_value__3Bicz"};